import {
  SUBMIT_ERROR_ACTION,
  getSubmitErrorConfig,
  isConfiguredSubmitErrorCode
} from '@configs/officialTopupNew/submitErrorConfig';
import {
  OPEN_GLOBAL_TIPS,
  UPDATE_LOADING,
  SET_HAS_LOAD_PAYTYPE,
  UPDATE_HAS_SELECT_PRODUCT,
  GET_SERVER_LIST,
  UPDATE_PAY_SUBMIT_PAGE_URL
} from '@store/officialTopupNew';
import { CLEAR_CART, SET_PRODUCT_OF_CART } from '@store/officialTopupNew/cart';
import {
  UPDATE_IS_SELECT_ROLE_POPUP,
  LOGOUT
} from '@store/officialTopupNew/login';
import { CLEAR_CASH_PARAMS } from '@store/officialTopupNew/cash';
import contactService from '@mixins/officialTopupNew/contactService';
import pay from '@mixins/officialTopupNew/pay';
import { showPopup, popupType } from '@plugins/biPoint/_configWebstoreV35';
import { safeOpenAiPanel } from '@services/officialTopupNew/payAssistant/instance';
import {
  trackSubmitErrorButtonClick,
  trackSubmitErrorPopupShow
} from '@utiles/officialTopupNew/submitErrorAnalytics';


function createEmptyPopupState() {
  return {
    type: 'tips',
    content: '',
    confirmText: '',
    cancelText: '',
    confirmAction: SUBMIT_ERROR_ACTION.CLOSE,
    cancelAction: SUBMIT_ERROR_ACTION.CLOSE,
    confirmTipKey: '',
    cancelTipKey: '',
    errorCode: ''
  };
}

export default {
  mixins: [contactService, pay],
  data() {
    return {
      showSubmitErrorPopup: false,
      submitErrorPopup: createEmptyPopupState()
    };
  },
  methods: {
    /**
     * 提单失败统一入口
     * @param {{ errmsg?: string, res?: { code?: number|string, data?: any } }} response
     */
    handleSubmitFail(response = {}) {
      const { errmsg, res } = response;
      // 2025-04-07 gmo升级v2需求：submit 失败则整个流程重新来
      this.amazonCheckoutSessionId = '';
      this.submitLoading = false;
      this.$store.commit(UPDATE_LOADING, false);

      // 兼容旧逻辑：购物车限购商品需移出
      if (res && +res.code === 120003 && res.data && Array.isArray(res.data) && res.data.length) {
        const hasDealItem = res.data.filter(item => item && !item.canBuy);
        if (hasDealItem.length) {
          this.removeCartItemToLimit(hasDealItem);
          return;
        }
      }

      this.showSubmitErrorByCode(res && res.code, errmsg);
    },

    showSubmitErrorByCode(code, fallbackMsg) {
      const config = getSubmitErrorConfig(code);
      const letter = this.letter || {};
      const content =
        (config.messageKey && letter[config.messageKey]) ||
        fallbackMsg ||
        letter.storeFailTips ||
        '';
      const buttons = config.buttons || SUBMIT_ERROR_DEFAULT_BUTTONS;
      const isSingle = buttons.length <= 1;
      const confirmBtn = isSingle ? buttons[0] : buttons[1];
      const cancelBtn = isSingle ? null : buttons[0];

      this.submitErrorPopup = {
        type: isSingle ? 'tips' : 'confirm',
        content,
        confirmText: this.resolveLetterText(confirmBtn && confirmBtn.textKey),
        cancelText: this.resolveLetterText(cancelBtn && cancelBtn.textKey),
        confirmAction: (confirmBtn && confirmBtn.action) || SUBMIT_ERROR_ACTION.CLOSE,
        cancelAction: (cancelBtn && cancelBtn.action) || SUBMIT_ERROR_ACTION.CLOSE,
        confirmTipKey: (confirmBtn && confirmBtn.tipKey) || '',
        cancelTipKey: (cancelBtn && cancelBtn.tipKey) || '',
        errorCode: code != null && code !== '' ? +code : ''
      };
      this.showSubmitErrorPopup = true;
      if (isConfiguredSubmitErrorCode(code)) {
        this.trackSubmitErrorPopupShow(code);
      }
    },

    getSubmitErrorTrackPayTypeFields() {
      const payType = this.curPayType || {};
      return {
        fPayType: payType.f_pay_type || '',
        payType: payType.pay_type || ''
      };
    },

    trackSubmitErrorPopupShow(code) {
      trackSubmitErrorPopupShow({
        code,
        ...this.getSubmitErrorTrackPayTypeFields()
      });
    },

    trackSubmitErrorButtonClick(buttonAction, buttonSlot) {
      const { errorCode } = this.submitErrorPopup;
      if (!isConfiguredSubmitErrorCode(errorCode)) return;
      trackSubmitErrorButtonClick({
        code: errorCode,
        buttonAction,
        buttonSlot,
        ...this.getSubmitErrorTrackPayTypeFields()
      });
    },

    resolveLetterText(key) {
      if (!key) return '';
      return (this.letter && this.letter[key]) || '';
    },

    handleSubmitErrorConfirm() {
      const { confirmAction, confirmTipKey } = this.submitErrorPopup;
      this.trackSubmitErrorButtonClick(confirmAction, 'confirm');
      this.showSubmitErrorPopup = false;
      this.executeSubmitErrorAction(confirmAction, confirmTipKey);
    },

    handleSubmitErrorCancel(operateType) {
      // 点遮罩/关闭/确认：不执行业务 action（confirm 由 handleSubmitErrorConfirm 处理）
      if (operateType === 'close' || operateType === 'confirm') {
        this.showSubmitErrorPopup = false;
        return;
      }
      const { cancelAction, cancelTipKey } = this.submitErrorPopup;
      this.trackSubmitErrorButtonClick(cancelAction, 'cancel');
      this.showSubmitErrorPopup = false;
      this.executeSubmitErrorAction(cancelAction, cancelTipKey);
    },

    executeSubmitErrorAction(action, tipKey) {
      switch (action) {
        case SUBMIT_ERROR_ACTION.CLOSE:
          break;
        case SUBMIT_ERROR_ACTION.GO_HOME:
          this.submitErrorGoHome();
          break;
        case SUBMIT_ERROR_ACTION.BACK_PRODUCT_LIST:
          this.submitErrorBackProductList();
          break;
        case SUBMIT_ERROR_ACTION.CLEAR_CART_BACK_PRODUCT:
          this.$store.commit(CLEAR_CART);
          this.submitErrorBackProductList();
          break;
        case SUBMIT_ERROR_ACTION.OPEN_ORDER_QUERY:
          this.submitErrorOpenOrderQuery();
          break;
        case SUBMIT_ERROR_ACTION.RETRY_PAY:
          this.$nextTick(() => {
            if (typeof this.postOrder === 'function') {
              this.postOrder();
            }
          });
          break;
        case SUBMIT_ERROR_ACTION.RELOAD:
          window.location.reload();
          break;
        case SUBMIT_ERROR_ACTION.SHOW_LOGIN:
          this.submitErrorShowLogin();
          break;
        case SUBMIT_ERROR_ACTION.SWITCH_PAY_TYPE:
          this.submitErrorSwitchPayType();
          break;
        case SUBMIT_ERROR_ACTION.OPEN_WORK_FORM:
          this.submitErrorOpenService();
          break;
        case SUBMIT_ERROR_ACTION.SHOW_SELECT_ROLE:
          this.submitErrorShowSelectRole();
          break;
        case SUBMIT_ERROR_ACTION.SHOW_TIP:
          this.submitErrorShowTip(tipKey);
          break;
        default:
          break;
      }
    },

    submitErrorGoHome() {
      this.submitErrorBackProductList();
      if (this.$route && this.$route.name !== 'home') {
        this.$router.push({ name: 'home' });
      }
    },

    submitErrorBackProductList() {
      if (typeof this.reSelectProduct === 'function') {
        this.reSelectProduct();
        return;
      }
      this.$store.commit(UPDATE_PAY_SUBMIT_PAGE_URL, '');
      this.$store.commit(CLEAR_CASH_PARAMS);
      this.$store.commit(SET_HAS_LOAD_PAYTYPE, false);
      this.$store.commit(UPDATE_HAS_SELECT_PRODUCT, false);
      this.$store.commit(UPDATE_LOADING, false);
    },
    /**
     * 调起到账查询助手界面
     * 仅在该游戏开启支付助手时拉起；未开启时弹窗已在 confirm 流程中关闭，无需额外处理
     * 【兜底】用 safeOpenAiPanel：助手未就绪/失败时不产生 UnhandledRejection
     */
    submitErrorOpenOrderQuery() {
      if (!this.$store.getters.isPayAssistantEnabled) {
        return;
      }
      void safeOpenAiPanel({
        inputValue: '',
        extensions: { skill: 'arrival_status' }
      });
    },

    submitErrorShowLogin() {
      this.$store.dispatch(LOGOUT).then(() => {
        window.location.reload();
      });
    },
    // 保持现有商品订单，重新请求支付方式并打开渠道选择
    submitErrorSwitchPayType() {
      if (typeof this.reloadWay === 'function') {
        this.reloadWay();
      }
      // 打开支付方式选择器，让玩家自行切换
      // if (typeof this.changePayType === 'function') {
      //   this.changePayType();
      //   return;
      // }
      // this.showPayWaySelecter = true;
    },
    submitErrorOpenService() {
    },
    submitErrorShowSelectRole() {
      this.submitErrorBackProductList();
      const serverList = this.$store.state.serverList;
      if (!serverList || !serverList.length) {
        this.$store.commit(UPDATE_LOADING, true);
        this.$store.dispatch(GET_SERVER_LIST).then(() => {
          this.$store.commit(UPDATE_LOADING, false);
          this.$store.commit(UPDATE_IS_SELECT_ROLE_POPUP, true);
          showPopup(popupType.charPopup);
        });
        return;
      }
      this.$store.commit(UPDATE_IS_SELECT_ROLE_POPUP, true);
      showPopup(popupType.charPopup);
    },

    submitErrorShowTip(tipKey) {
      const tip =
        this.resolveLetterText(tipKey) ||
        this.resolveLetterText('v3SubmitErrTipRelogin');
      if (tip) {
        this.$store.commit(OPEN_GLOBAL_TIPS, tip);
      }
    },

    removeCartItemToLimit(hasDealItem) {
      hasDealItem &&
        hasDealItem.length &&
        hasDealItem.forEach(item => {
          this.$store.commit(SET_PRODUCT_OF_CART, item);
        });
      this.submitLoading = false;
      this.$store.commit(UPDATE_LOADING, false);
      this.$store.commit(OPEN_GLOBAL_TIPS, this.letter.limit_order_remove_tip);
    }
  }
};

const SUBMIT_ERROR_DEFAULT_BUTTONS = [
  { textKey: 'v3Confirm', action: SUBMIT_ERROR_ACTION.CLOSE }
];
